module.exports = __webpack_public_path__ + "img/mission-gfj-header.jpg?1eda0af5cd324089621a90cecb0e4b22";